import { createResizeObserver } from '@js/vue/directives/utils/calc-dimension-observer.js';

export default {
	mounted(el, binding) {
		const config = typeof binding.value === 'object'
			? binding.value
			: { var: binding.value };

		const varName = config.var || 'width';
		const target = config.self ? el : document.documentElement;

		createResizeObserver(el, varName, (element) => element.offsetWidth, target);
	},

	beforeUnmount(el) {
		// Clean up observer when element is removed
		if (el._resizeObserver) {
			el._resizeObserver.disconnect();
			delete el._resizeObserver;
		}
	}
};
